import type {Optional} from '@yandex-delivery/types'
import {get} from '@yandex-delivery/utils'

import type {Point, PointID} from 'src/shared/types'

export const getPointId: (point?: Point) => Optional<PointID> = get('_id')
